import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { API_ROUTE_DOCUMENT } from '@app/forms/subscription/api/api-router';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { catchError, finalize, take } from 'rxjs';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-documentation-assureur',
    templateUrl: './credit-documentation-assureur.component.html',
    styleUrls: ['./credit-documentation-assureur.component.scss'],
    standalone: false
})
export class CreditDocumentationAssureurComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  pledge: PledgeRead;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private httpApiService: HttpApiService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  get insurerDocuments(): UntypedFormArray {
    return this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('insurerDocuments') as UntypedFormArray;
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  onClickDownloadDocument(label: string, gedId: number) {
    const route = API_ROUTE_DOCUMENT.replace(
      ':accountId',
      this.entity?.accountId,
    ).replace(':documentId', gedId.toString());

    this.httpApiService
      .getWithOptions(route, {
        responseType: 'arraybuffer',
      })
      .pipe(
        take(1),
        catchError(err => {
          console.error(err);
          return err;
        }),
        finalize(() => {}),
      )
      .subscribe(resp => {
        var blob = new Blob([resp], { type: 'application/pdf' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        label = label.replace(/ /g, '_').toLowerCase();
        link.download = `${label}.pdf`;
        link.click();
      });
  }
}
